import React, { useRef, useState, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import Logo from './logo'
import Toggler from './toggler'
import * as Styles from './styles'
import LogoGrafeno from './logo-grafeno'

type Props = {
  children: JSX.Element
  collapsed: boolean
  urlLogo?: string
  urlLogoIcon?: string
  useRouter?: boolean
}
/**
 *
 * @deprecated This will be removed in the future. Use SideMenuAlt
 */

const SideMenu: React.FC<any> = (props: Props) => {
  const [collapsed, setCollapsed] = useState(props.collapsed)
  const onToggle = (newState: boolean): void => setCollapsed(newState)
  const showLogo = !!props.urlLogo
  const [scrollPosition, setScrollPosition] = useState(null)

  const sideMenuRef = useRef<HTMLDivElement>()

  function onScroll() {
    const scroll = sideMenuRef.current.scrollTop
    setScrollPosition(scroll)
  }

  useEffect(() => {
    setCollapsed(props.collapsed)
  }, [props.collapsed])

  return (
    <ThemeProvider theme={{ collapsed: collapsed }}>
      <Styles.Container>
        <Styles.SideMenu>
          {showLogo && (
            <Logo
              compact={collapsed}
              urlImage={props.urlLogo}
              urlImageIcon={props.urlLogoIcon}
            />
          )}
          {!showLogo && <LogoGrafeno compact={collapsed} />}
          <Styles.ContentWrapper
            ref={sideMenuRef}
            onScroll={onScroll}
            position={scrollPosition}
          >
            {props.children}
          </Styles.ContentWrapper>
        </Styles.SideMenu>
        <Toggler collapsed={collapsed} onToggle={onToggle} />
      </Styles.Container>
    </ThemeProvider>
  )
}

export default SideMenu
